import React, { useState } from 'react';
import { Monitor } from 'lucide-react';
import useIsMobile from '../../hooks/useIsMobile';
import LogoFull from '../logos/LogoFull';

const DISMISSED_KEY = 'helix_mobile_gate_dismissed';

const MobileGate = ({ children }) => {
    const isMobile = useIsMobile();
    const [dismissed, setDismissed] = useState(() => {
        return sessionStorage.getItem(DISMISSED_KEY) === 'true';
    });

    const handleDismiss = () => {
        sessionStorage.setItem(DISMISSED_KEY, 'true');
        setDismissed(true);
    };

    if (!isMobile || dismissed) {
        return children;
    }

    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[var(--bg-dark)] p-6 text-center">
            {/* Ambient effects */}
            <div className="absolute top-[-20%] right-[-10%] w-[400px] h-[400px] bg-[var(--primary-color)] opacity-[0.06] blur-[120px] rounded-full pointer-events-none" />
            <div className="absolute bottom-[-20%] left-[-10%] w-[300px] h-[300px] bg-[var(--secondary-color)] opacity-[0.08] blur-[100px] rounded-full pointer-events-none" />

            <div className="relative z-10 max-w-sm w-full">
                <LogoFull className="h-16 mx-auto mb-8" />

                <div className="glass-panel p-8 rounded-2xl border border-[rgba(255,255,255,0.1)]">
                    <Monitor size={48} className="mx-auto mb-4 text-[var(--primary-color)]" />
                    <h2 className="text-xl font-heading font-bold text-white mb-3">Desktop Required</h2>
                    <p className="text-[var(--text-secondary)] text-sm leading-relaxed mb-6">
                        Helix needs room to breathe. Open on a desktop or tablet for the full experience.
                    </p>
                    <button
                        onClick={handleDismiss}
                        className="w-full py-3 rounded-lg border border-[var(--border-glass)] text-[var(--text-secondary)] hover:text-white hover:bg-[rgba(255,255,255,0.05)] transition-all text-sm font-medium"
                    >
                        Continue Anyway
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MobileGate;
